import {
  finishLoading,
  startLoading,
} from '../../../connected-components/loading/actions';
import {services} from '../../../api';
import {showGlobalToast} from '../../../connected-components/toast/actions';
import {tr} from '../../../translations';
import {ToastType} from '../../../utils/enums';

export interface ResetPasswordBody {
  email: string;
  token: string;
  password: string;
}

/**
 * this function to reset password with OTP code
 *
 * @param body - email, token (OTP code), and new password
 */
export const resetPassword = async (
  body: ResetPasswordBody,
): Promise<{success: boolean; message?: string}> => {
  try {
    startLoading();
    await services.auth.resetPassword(body);
    
    // Show success message
    showGlobalToast({
      message: tr('resetPassword.successMessage'),
      type: ToastType.SUCCESS,
    });
    
    return {success: true};
  } catch (error: any) {

    const message = error?.response?.data?.error?.message
      ? error?.response?.data?.error?.message
      : tr('app.error');

    return {success: false, message};
  } finally {
    finishLoading();
  }
};

